// Resolve each room independently. A conversion overrides the Look starting layout;
// deselecting it restores that starting layout without buying an alternative upgrade.
export const applyBathroomLayouts = (categories) => {
    const selectedByRoom = new Map();
    categories.forEach(category => {
        if (!category.disabled && category.selected_feature) {
            const feature = category.features.find(f => f.id === category.selected_feature);
            if (feature && !feature.disabled) {
                if (!selectedByRoom.has(category.roomId)) selectedByRoom.set(category.roomId, new Set());
                selectedByRoom.get(category.roomId).add(feature.id);
            }
        }
    });

    categories.forEach(category => {
        const layout = category.bathroom_layout;
        if (!layout) return;
        const selected = selectedByRoom.get(category.roomId) || new Set();
        const bathConversion = (layout.bathtubConversionIds || []).some(id => selected.has(id));
        const showerConversion = (layout.showerConversionIds || []).some(id => selected.has(id));
        const currentLayout = bathConversion && showerConversion ? 'Conflict'
            : bathConversion ? 'Bathtub' : showerConversion ? 'Shower' : layout.initialLayout;
        category.features.forEach(feature => {
            const bath = (layout.bathtubFeatureIds || []).includes(feature.id);
            const shower = (layout.showerFeatureIds || []).includes(feature.id);
            feature.bathroomUnavailable = null;
            if (!bath && !shower) return;
            if (currentLayout === 'Conflict' || (bath && shower)) {
                feature.bathroomUnavailable = 'La configuración de bañera y ducha de este baño es contradictoria.';
            } else if (bath && currentLayout === 'Shower') {
                feature.bathroomUnavailable = 'Este baño tiene ducha. Esta opción requiere bañera.';
            } else if (shower && currentLayout === 'Bathtub') {
                feature.bathroomUnavailable = 'Este baño tiene bañera. Esta opción requiere ducha.';
            }
            if (feature.bathroomUnavailable && category.selected_feature === feature.id) {
                category.selected_feature = 0;
            }
        });
    });
};
